import { css } from "@emotion/react"
import getMediaQuery from "css/breakpoints"

export const columnWidth = css`
  &.width-s,
  &.width-m,
  &.width-l {
    grid-column: col 1 / span 6;
  }

  &.width-xl {
    grid-column: doc;
  }

  ${getMediaQuery("m")} {
    &.width-s {
      grid-column: col 4 / span 6;
    }

    &.width-m {
      grid-column: col 2 / span 10;
    }

    &.width-l {
      grid-column: main;
    }
  }
`
